<script setup lang="ts">
defineProps<{
  items: readonly unknown[]
  visible: boolean
  activeIndex: number
  itemKey: (item: unknown, index: number) => string | number
  itemLabel: (item: unknown) => string
}>()

const emit = defineEmits<{
  activate: [index: number]
  select: [item: unknown]
}>()
</script>

<template>
  <ul
    v-show="visible"
    class="ui-menu ui-widget ui-widget-content ui-autocomplete ui-front form-autocomplete-menu"
    role="listbox"
  >
    <li
      v-for="(item, index) in items"
      :key="itemKey(item, index)"
      class="ui-menu-item"
      role="presentation"
      @mouseenter="emit('activate', index)"
      @mouseleave="emit('activate', -1)"
      @mousedown.prevent="emit('select', item)"
    >
      <div
        class="ui-menu-item-wrapper"
        :class="{ 'ui-state-active': index === activeIndex }"
        role="option"
        :aria-selected="index === activeIndex"
      >
        {{ itemLabel(item) }}
      </div>
    </li>
  </ul>
</template>
